import { createSlice } from '@reduxjs/toolkit'

// Setup the initial state

const initialState = {
  insertJob: {},
  insertIncome: {},
  deleteJob: {},
  consultJob: {},
  insertBusiness: {},
  insertBusinessClient: {},
  insertBusinessProvider: {},
  deleteBusiness: {},
  consultBusiness: {},
};

export const jobsSlice = createSlice({
  name: 'jobs',
  initialState,
  reducers: {

    // Insert Client Job

    setInsertJobLoading: (state) => {
      state.insertJob = {
        isLoading: true,
      };
    },

    setInsertJobSuccess: (state) => {
      state.insertJob = {
        success: true
      };
    },

    setInsertJobFailure: (state, action) => {
      state.insertJob = {
        error: action.payload,
      }
    },

    clearInsertJob: (state) => {
      state.insertJob = {}
    },

    // Insert Client Income

    setInsertIncomeLoading: (state) => {
      state.insertIncome = {
        isLoading: true,
      };
    },

    setInsertIncomeSuccess: (state) => {
      state.insertIncome = {
        success: true
      };
    },

    setInsertIncomeFailure: (state, action) => {
      state.insertIncome = {
        error: action.payload,
      }
    },

    clearInsertIncome: (state) => {
      state.insertIncome = {}
    },

    // Delete Client Job

    setDeleteJobLoading: (state) => {
      state.deleteJob = {
        isLoading: true,
      };
    },

    setDeleteJobSuccess: (state) => {
      state.deleteJob = {
        success: true
      };
    },

    setDeleteJobFailure: (state, action) => {
      state.deleteJob = {
        error: action.payload,
      }
    },

    clearDeleteJob: (state) => {
      state.deleteJob = {}
    },

    // Consult Jobs

    setConsultJobLoading: (state) => {
      state.consultJob = {
        isLoading: true,
      };
    },

    setConsultJobSuccess: (state, action) => {
      state.consultJob = {
        data: action.payload
      };
    },

    setConsultJobFailure: (state, action) => {
      state.consultJob = {
        error: action.payload,
      }
    },

    // Insert Client Business

    setInsertBusinessLoading: (state) => {
      state.insertBusiness = {
        isLoading: true,
      };
    },

    setInsertBusinessSuccess: (state, action) => {
      state.insertBusiness = {
        data: action.payload,
        success: true
      };
    },

    setInsertBusinessFailure: (state, action) => {
      state.insertBusiness = {
        error: action.payload,
      }
    },

    clearInsertBusiness: (state) => {
      state.insertBusiness = {}
    },

    // Insert Client Business Client

    setInsertBusinessClientLoading: (state) => {
      state.insertBusinessClient = {
        isLoading: true,
      };
    },

    setInsertBusinessClientSuccess: (state, action) => {
      state.insertBusinessClient = {
        success: true
      };
    },

    setInsertBusinessClientFailure: (state, action) => {
      state.insertBusinessClient = {
        error: action.payload,
      }
    },

    clearInsertBusinessClient: (state) => {
      state.insertBusinessClient = {}
    },

    // Insert Client Business Provider

    setInsertBusinessProviderLoading: (state) => {
      state.insertBusinessProvider = {
        isLoading: true,
      };
    },

    setInsertBusinessProviderSuccess: (state, action) => {
      state.insertBusinessProvider = {
        success: true
      };
    },

    setInsertBusinessProviderFailure: (state, action) => {
      state.insertBusinessProvider = {
        error: action.payload,
      }
    },

    clearInsertBusinessProvider: (state) => {
      state.insertBusinessProvider = {}
    },

    // Delete Client Business

    setDeleteBusinessLoading: (state) => {
      state.deleteBusiness = {
        isLoading: true,
      };
    },

    setDeleteBusinessSuccess: (state) => {
      state.deleteBusiness = {
        success: true
      };
    },

    setDeleteBusinessFailure: (state, action) => {
      state.deleteBusiness = {
        error: action.payload,
      }
    },

    clearDeleteBusiness: (state) => {
      state.deleteBusiness = {}
    },

    
    // Consult Client Business

    setConsultBusinessLoading: (state) => {
      state.consultBusiness = {
        isLoading: true,
      };
    },

    setConsultBusinessSuccess: (state, action) => {
      state.consultBusiness = {
        data: action.payload
      };
    },

    setConsultBusinessFailure: (state, action) => {
      state.consultBusiness = {
        error: action.payload,
      }
    },

  },
})

export const {
  setInsertJobLoading, setInsertJobSuccess, setInsertJobFailure, clearInsertJob,
  setInsertIncomeLoading, setInsertIncomeSuccess, setInsertIncomeFailure, clearInsertIncome,
  setDeleteJobLoading, setDeleteJobSuccess, setDeleteJobFailure,clearDeleteJob,
  setConsultJobLoading, setConsultJobSuccess, setConsultJobFailure,
  setInsertBusinessLoading, setInsertBusinessSuccess, setInsertBusinessFailure, clearInsertBusiness,
  setInsertBusinessClientLoading, setInsertBusinessClientSuccess, setInsertBusinessClientFailure, clearInsertBusinessClient,
  setInsertBusinessProviderLoading, setInsertBusinessProviderSuccess, setInsertBusinessProviderFailure, clearInsertBusinessProvider,
  setDeleteBusinessLoading, setDeleteBusinessSuccess, setDeleteBusinessFailure, clearDeleteBusiness,
  setConsultBusinessLoading, setConsultBusinessSuccess, setConsultBusinessFailure,
} = jobsSlice.actions

export default jobsSlice.reducer;